var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72011 8.87149C10.4413 9.12301 11.2186 9.15927 11.9595 8.97596C12.7005 8.79265 13.374 8.39747 13.9001 7.83735C14.4262 7.27723 14.7828 6.5757 14.9276 5.81606C15.0723 5.05643 14.9991 4.27061 14.7167 3.55192L11.5689 6.74528L9.32166 4.45738L12.4615 1.28019C11.726 0.986912 10.9212 0.922121 10.1493 1.09406C9.37743 1.26599 8.6734 1.66688 8.12669 2.24577C7.57998 2.82465 7.2153 3.55539 7.07901 4.34507C6.94272 5.13475 7.04097 5.94771 7.36127 6.6806L1 12.7121L3.25525 15L9.72011 8.87149Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTool);
export default __webpack_public_path__ + "static/media/icon-tool.df478fb31252fc8797f2c6ae5ffb8d3d.svg";
export { ForwardRef as ReactComponent };